import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0fbf1cdb&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=0fbf1cdb&prod&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=0fbf1cdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf1cdb",
  null
  
)

export default component.exports